import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "payment-result-area" }
const _hoisted_2 = { class: "payment-result-card" }
const _hoisted_3 = { class: "result-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "result-icon cancel" }, [
        _createElementVNode("i", { class: "ti ti-x" })
      ], -1)),
      _cache[3] || (_cache[3] = _createElementVNode("h1", null, "Payment Cancelled", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("p", null, "Your payment was cancelled and you have not been charged. You can try again whenever you're ready.", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RouterLink, {
          to: "/#pricing",
          class: "btn"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("span", { class: "border-style" }, "View Pricing Plans", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_RouterLink, {
          to: "/",
          class: "result-secondary-link"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Back to Home")
          ])),
          _: 1
        })
      ])
    ])
  ]))
}